import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { EavAttributeValueTypeEnum } from '@zaoblako/shared/modules/eav/enums/eav-attribute-value-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link EavAttributeValueTypeEnum} enumeration value */
export const EavAttributeValueTypeEnumI18n: EnumI18nInterface<EavAttributeValueTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [EavAttributeValueTypeEnum.BOOLEAN]: 'Да/Нет',
    [EavAttributeValueTypeEnum.NUMBER]: 'Число',
    [EavAttributeValueTypeEnum.TEXT]: 'Текст',
    [EavAttributeValueTypeEnum.DATE]: 'Дата',
    [EavAttributeValueTypeEnum.TIMESTAMP]: 'Дата и время',
    [EavAttributeValueTypeEnum.DATE_PERIOD]: 'Период',
    [EavAttributeValueTypeEnum.COMPUTED]: 'Вычисляемое поле',
    [EavAttributeValueTypeEnum.FILES]: 'Файлы',
    [EavAttributeValueTypeEnum.FILIAL]: 'Филиал',
    [EavAttributeValueTypeEnum.COST_CENTER]: 'Центр затрат',
    [EavAttributeValueTypeEnum.ROOM]: 'Помещение',
  },
  [I18nLocalesEnum.EN_US]: {
    [EavAttributeValueTypeEnum.BOOLEAN]: 'Yes/No',
    [EavAttributeValueTypeEnum.NUMBER]: 'Number',
    [EavAttributeValueTypeEnum.TEXT]: 'Text',
    [EavAttributeValueTypeEnum.DATE]: 'Date',
    [EavAttributeValueTypeEnum.TIMESTAMP]: 'Timestamp',
    [EavAttributeValueTypeEnum.DATE_PERIOD]: 'Period',
    [EavAttributeValueTypeEnum.COMPUTED]: 'Computed',
    [EavAttributeValueTypeEnum.FILES]: 'Files',
    [EavAttributeValueTypeEnum.FILIAL]: 'Filial',
    [EavAttributeValueTypeEnum.COST_CENTER]: 'Cost center',
    [EavAttributeValueTypeEnum.ROOM]: 'Room',
  },
};
